//音乐热点
import Music from '../../components/mymusic';

function setWxAutoPlayMusic() {
  //设置自动播放的空音乐
  //设置背景音乐
  this.explainMusic = new Music({
    src: '/static/music/empty.mp3',
    id:'explainMusic',
    autoplay: 1,
    loop: 0,
    volume:1,
    wrapper: this.$container.get(0),
  });
  //设置解说音乐
  this.bgmusic = new Music({
    src: '/static/music/empty.mp3',
    id:'bgMusic',
    autoplay: 1,
    loop: 0,
    volume:1,
    wrapper: this.$container.get(0),
  });
}

function setSceneMusic(musicBg, musicExplain) {
  //设置背景音乐
  this.setBgMusic({
    src: musicBg && musicBg.url != 'null' ? musicBg.url : '',
    loop: musicBg && musicBg.loop == 1 ? 0 : 1, //反
    autoplay: musicBg && musicBg.autoplay == 1 ? 1 : 0,
    volume:musicBg && musicBg.volume ? Number(musicBg.volume) * 0.01 : 1,
  });
  //设置解说音乐
  this.setExplainMusic({
    src: musicExplain && musicExplain.url != 'null' ? musicExplain.url : '',
    loop: musicExplain && musicExplain.loop == 1 ? 0 : 1, //反
    autoplay: musicExplain && musicExplain.autoplay == 1 ? 1 : 0,
    volume:musicExplain && musicExplain.volume ? Number(musicExplain.volume) * 0.01 : 1,
  });
}

function setHotspotMusic(data) {
  //热点音乐
  if (!data) return;
  const { musicUrl, id } = data;

  if (this.hotspotMusic) {
    if (this.hotspotMusic.params.id === data.id) {
      this.toggleHotspotMusic();
    } else {
      this.hotspotMusic.change({
        src: musicUrl,
        autoplay: 1,
        loop: 0,
        id: id,
        volume: 1,
      });
    }
  } else {
    this.hotspotMusic = new Music({
      src: musicUrl,
      autoplay: 1,
      loop: 0,
      id: id,
      volume: 1,
      wrapper: this.$container.get(0),
    });
  }

  //暂停别的音乐 等等、、、、、
  this.bgMusicPause();
  this.explainMusicPause();
}
function hotspotMusicPause() {
  //暂停热点音乐
  if (this.hotspotMusic) {
    this.hotspotMusic.pause();
  }
}
function setBgMusic(data) {
  if (!data || !data.src) {
    this.bgMusicPause();
    this.removeBgMusic();
    return;
  }
  if (typeof this.userBgMusicPlay === 'boolean') {
    data.autoplay = this.userBgMusicPlay ? 1 : 0;
  }

  if (this.bgmusic) {
    const { params } = this.bgmusic;
    if (params.src != data.src) {
      //地址不同重新播放
      this.bgmusic.change({ ...data });
      this.bgmusic.changeAutoplay(data.autoplay);
      this.bgmusic.changeLoop(data.loop);
      this.bgmusic.changeVolume(data.volume);
    } else {
      //地址相同改变属性
      this.bgMusicPause();
      this.bgmusic.changeAutoplay(data.autoplay);
      this.bgmusic.changeLoop(data.loop);
      this.bgmusic.changeVolume(data.volume);
      data.autoplay ? this.bgMusicPlay() : this.bgMusicPause();
    }
  } else {
    this.bgmusic = new Music({
      id:'bgMusic',
      ...data,
      wrapper: this.$container.get(0),
    });
    this.bgMusicPlay();
  }

  if (!data.autoplay) {
    this.setBgMusicCrop(false);
  } else {
    this.setBgMusicCrop(true);
  }
}

function setExplainMusic(data) {
  if (!data || !data.src) {
    this.explainMusicPause();
    this.removeExplainMusic();
    return;
  }
  if (typeof this.userExplainMusicPlay === 'boolean') {
    data.autoplay = this.userExplainMusicPlay ? 1 : 0;
  }
  if (this.explainMusic) {
    const { params } = this.explainMusic;
    if (params.src != data.src) {
      //地址不同重新播放
      this.explainMusic.change({ ...data });
      this.explainMusic.changeAutoplay(data.autoplay);
      this.explainMusic.changeLoop(data.loop);
      this.explainMusic.changeVolume(data.volume);
    } else {
      //地址相同改变属性
      this.explainMusicPause();
      this.explainMusic.changeAutoplay(data.autoplay);
      this.explainMusic.changeLoop(data.loop);
      this.explainMusic.changeVolume(data.volume);
      data.autoplay ? this.explainMusicPlay() : this.explainMusicPause();
    }
  } else {
    this.explainMusic = new Music({
      id:'explainMusic',
      ...data,
      wrapper: this.$container.get(0),
    });
    this.explainMusicPlay();
  }
  if (!data.autoplay) {
    this.setExplainMusicCrop(false);
  } else {
    this.setExplainMusicCrop(true);
  }
}

function removeBgMusic() {
  if (document.getElementById('bgMusic')) {
    this.bgMusicPause();
    document.getElementById('bgMusic').remove();
  }
    
  this.setBgMusicCrop(false);
  this.bgmusic = null;
}

function removeExplainMusic() {
  if (document.getElementById('explainMusic')) {
    this.explainMusicPause();
    document.getElementById('explainMusic').remove();
  } 
  this.setExplainMusicCrop(false);
  this.explainMusic = null;
}

function toggleBgMusic() {
  if (document.getElementById('bgMusic').paused) {
    this.bgMusicPlay();
  } else {
    this.bgMusicPause();
  }
}

function toggleExplainMusic() {
  if (document.getElementById('explainMusic').paused) {
    this.explainMusicPlay();
  } else {
    this.explainMusicPause();
  }
}
function toggleHotspotMusic() {
  if (!this.hotspotMusic) return;
  if (this.hotspotMusic.paused) {
    this.hotspotMusic.play();
  } else {
    this.hotspotMusic.pause();
  }
}

function bgMusicPlay() {
  //设置热点图片crop播放  暂停别的音乐等等。。。
  if (document.getElementById('bgMusic')) {
    // this.bgmusic.play();
    document.getElementById('bgMusic').play();
    this.hotspotMusicPause();
    this.setBgMusicCrop(true);
  }
}

function bgMusicPause() {
  //设置热点图片crop暂停
  if (document.getElementById('bgMusic')) {
    // this.bgmusic.pause();
    document.getElementById('bgMusic').pause();
    this.setBgMusicCrop(false);
  }
}

function explainMusicPlay() {
  //设置热点图片crop播放 暂停别的音乐等等。。。
  if (document.getElementById('explainMusic')) {
    // this.explainMusic.play();
    document.getElementById('explainMusic').play();
    this.hotspotMusicPause();
    this.setExplainMusicCrop(true);
  }
}

function explainMusicPause() {
  //设置热点图片crop暂停
  if (document.getElementById('explainMusic')) {
    // this.explainMusic.pause();
    document.getElementById('explainMusic').pause();
    this.setExplainMusicCrop(false);
  }
}

function setBgMusicCrop(value) {
  if (value) {
    this.setBtnBg('musicBg_img',true);
  } else {
    this.setBtnBg('musicBg_img',false);
  }
}

function setExplainMusicCrop(value) {
  if (value) {
    this.setBtnBg('musicExplain_img',true);
  } else {
    this.setBtnBg('musicExplain_img',false);
  }
}

function pauseAllMusic() {
  this.bgMusicPause();
  this.explainMusicPause();
  this.hotspotMusicPause();
}

function onUserChangeBgmusic() {
  if (!document.getElementById('bgMusic')) return;
  if (document.getElementById('bgMusic').paused) {
    this.userBgMusicPlay = true;
  } else {
    this.userBgMusicPlay = false;
  }
  this.toggleBgMusic();
}
function onUserChangeExplainmusic() {
  if (!document.getElementById('explainMusic')) return;
  if (document.getElementById('explainMusic').paused) {
    this.userExplainMusicPlay = true;
  } else {
    this.userExplainMusicPlay = false;
  }
  this.toggleExplainMusic();
}

export default {
  setSceneMusic,
  setHotspotMusic,
  setBgMusic,
  setExplainMusic,
  toggleBgMusic,
  toggleExplainMusic,
  toggleHotspotMusic,
  bgMusicPlay,
  bgMusicPause,
  explainMusicPlay,
  explainMusicPause,
  hotspotMusicPause,
  pauseAllMusic,
  removeExplainMusic,
  removeBgMusic,
  setBgMusicCrop,
  setExplainMusicCrop,
  onUserChangeExplainmusic,
  onUserChangeBgmusic,
  setWxAutoPlayMusic,
};
